import styled from 'styled-components/macro'

export const ResetFormBody = styled.form``
